var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBoxClose = function SvgBoxClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2056 5.21865H9.35937V4.07375C9.35937 1.86422 7.58788 0.0666504 5.41034 0.0666504C3.2328 0.0666504 1.46131 1.86422 1.46131 4.07375V5.21865H0.615091C0.459174 5.21865 0.333008 5.34667 0.333008 5.50488V12.6604C0.333008 13.2919 0.839022 13.8053 1.46131 13.8053H9.35939C9.98166 13.8053 10.4877 13.2919 10.4877 12.6604V5.50488C10.4877 5.34667 10.3615 5.21865 10.2056 5.21865ZM6.25492 11.1977C6.26373 11.2785 6.23813 11.3596 6.18469 11.4202C6.13124 11.4809 6.05466 11.5155 5.97451 11.5155H4.8462C4.76605 11.5155 4.68946 11.4809 4.63602 11.4202C4.58258 11.3596 4.55695 11.2785 4.56578 11.1977L4.74373 9.57405C4.45477 9.36078 4.28206 9.0234 4.28206 8.65332C4.28206 8.0219 4.78808 7.50842 5.41037 7.50842C6.03266 7.50842 6.53867 8.02187 6.53867 8.65332C6.53867 9.0234 6.36596 9.36078 6.077 9.57405L6.25492 11.1977ZM7.66692 5.21865H3.15376V4.07375C3.15376 2.81119 4.16608 1.78398 5.41034 1.78398C6.6546 1.78398 7.66692 2.81119 7.66692 4.07375V5.21865Z",
    fill: "#9F9F9F"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBoxClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/box-close.ce8e9af1.svg";
export { ForwardRef as ReactComponent };